<template lang="pug">
  v-dialog(
    v-model="show"
    persistent
    scrollable
    lazy
    width="500"
    content-class="create-contact-choice-modal"
  )
    v-card
      .dialog-header
        v-card-title.card-title Create Contact
        v-btn.icon.close-btn(@click="onCancel" aria-label="Close")
          v-icon close
      v-card-text
        .option-group
          .option(
            :class="{ selected: selectedOption === 'liondesk' }"
            @click="selectedOption = 'liondesk'"
          )
            v-icon.radio-icon {{ selectedOption === 'liondesk' ? 'radio_button_checked' : 'radio_button_unchecked' }}
            img.option-icon(src="https://assets.lwolf.com/img/lw-logo-dark.svg" alt="LionDesk" width="32" height="32")
            span.option-label LionDesk
            .option-desc Your usual and familiar way to create contact

          .option(
            :class="{ selected: selectedOption === 'relationships' }"
            @click="selectedOption = 'relationships'"
            style="position: relative;"
          )
            span.new-label New!
            v-icon.radio-icon {{ selectedOption === 'relationships' ? 'radio_button_checked' : 'radio_button_unchecked' }}
            img.option-icon(src="https://assets.lwolf.com/img/lw-logo-dark.svg" alt="Relationships" width="32" height="32")
            span.option-label Relationships
            .option-desc Seamless contact creation at its best!
        .video-section
          p.relationships-copy Stronger connections start here! Watch how Relationships transforms your contacts into lasting relationships.
          iframe(
            title="Managing Contacts" 
            src="//play.vidyard.com/ji29dyAUtRs8Xccc6uRdhh.html?" 
            width=434 
            height=242 
            scrolling="no" 
            frameborder="0" 
            allowtransparency="true" 
            allowfullscreen 
            referrerpolicy="no-referrer-when-downgrade"
          )
      v-card-actions
        v-spacer
        v-btn(flat color="primary" @click="onCancel").cancel-btn Cancel
        v-btn(@click="onCreateContact").create-btn Create Contact
</template>

<script>
export default {
  name: 'CreateContactChoiceModal',
  props: {
    show: Boolean
  },
  data() {
    return {
      selectedOption: 'relationships',
    };
  },
  methods: {
    onCancel() {
      this.$emit('close');
    },
    onCreateContact() {
      this.$emit('create', this.selectedOption);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-dialog.create-contact-choice-modal,
::v-deep .v-dialog.create-contact-choice-modal .v-card,
::v-deep .v-dialog.create-contact-choice-modal .v-sheet {
  border-radius: 8px !important;
}

.dialog-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 24px 34px!important;
}

.card-title {
  font-size: 24px;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  padding: 0px!important;
}

.v-card__text{
  padding: 8px 34px 24px 34px!important;
}

.option-group {
  margin-bottom: 16px;
}

.option {
  display: flex;
  align-items: center;
  justify-content: start;
  cursor: pointer;
  border: 1px solid #dddddd;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 10px;
  transition: border 0.2s;
  position: relative;
  height: 72px;
}

.option.selected {
  border: 1px solid #2ecc40;
  background: #f6fff6bc;
}

.option-label {
  display: flex;
  align-items: center;
}

.option-desc {
  display: block;
  font-size: 0.9em;
  color: var(--v-secondary-lighten1);
  margin-left: auto;
}

.new-label {
  color: #2ecc40;
  font-weight: bold;
  font-size: 10px;
  position: absolute;
  top: 2px;
  left: 4px;
}

.option-label {
  font-size: 14px;
  font-weight: bold;
}

.radio-icon {
  margin-right: 8px;
  color: #2ecc40;
}

.option-icon {
  margin-right: 8px;
}

.video-section {
  margin: 24px 0 12px 0;
  text-align: center;
}

.video-section iframe {
  border: none !important;
  border-radius: 8px;
  background: transparent;
}

.relationships-copy {
  font-style: italic;
  font-size: 13px;
  margin-bottom: 8px;
}

.video-player {
  width: 100%;
  height: 200px;
  border-radius: 8px;
  background: transparent;
}

.create-btn {
  background-color: rgb(35, 104, 71) !important;
  color: #fff;
  border-radius: 6px;
  box-shadow: 0 0 2px 0 rgba(0,0,0,0.2), 0 1px 2px 0 rgba(0,0,0,0.1);
  font-family: -apple-system, "system-ui", "Segoe UI", Roboto, "Open Sans", Ubuntu, "Droid Sans", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 14px;
  font-weight: 600;
  text-transform: none;
  height: 28px;
  min-height: 28px;
  max-height: 28px;
  padding: 4px 8px;
  margin-left: 16px !important;
  width: 130.664px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  line-height: 18px;
  position: relative;
  user-select: none;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  -webkit-font-smoothing: antialiased;
}

.create-btn:active,
.create-btn:focus {
  outline: none;
}

.cancel-btn {
  background-color: rgb(229, 231, 235) !important;
  color: rgb(75, 85, 99) !important;
  border-radius: 6px;
  font-family: -apple-system, "system-ui", "Segoe UI", Roboto, "Open Sans", Ubuntu, "Droid Sans", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 14px;
  font-weight: 600;
  text-transform: none;
  height: 28px;
  min-height: 28px;
  max-height: 28px;
  padding: 4px 8px;  
  width: 94px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  line-height: 18px;
  position: relative;
  user-select: none;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  -webkit-font-smoothing: antialiased;
}

.cancel-btn:active,
.cancel-btn:focus {
  outline: none;
}

.v-card__actions {
  border-top: solid 1px var(--v-background-lighten4);
  padding-right: 0px !important;
  padding-bottom: 40px !important;
  width: 432px !important;
  margin-left: auto;
  margin-right: auto;
}

.close-btn {
  min-width: 24px;
  min-height: 32px;
  width: 24px;
  height: 32px;
  color: var(--v-secondary-lighten3);
  background-color: transparent !important;
  padding: 0px !important;
  margin: 0px !important;
  transition: all .2s ease-in-out;
}

.close-btn:hover {
  color: var(--v-secondary-base);
  transform: scale(1.1);
}

::v-deep .v-btn.close-btn::before,
::v-deep .v-btn.close-btn:hover::before,
::v-deep .v-btn.close-btn:focus::before,
::v-deep .v-btn.icon.close-btn::before,
::v-deep .v-btn.icon.close-btn:hover::before,
::v-deep .v-btn.icon.close-btn:focus::before {
  background-color: transparent !important;
}
</style> 